import React from "react";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

const radioButtonStyle = {
  ".MuiFormControlLabel-label": {
    fontSize: "1.4rem",
    color: "#344054",
    lineHeight: "2rem",
    fontFamily: "Inter-Medium",
  },
};
function CustomRadio({
  value,
  optionList,
  onChangeValue,
  helperText = "",
  checked,
  gap,
}) {
  return (
    <div>
      <FormControl style={{ fontSize: "1.5rem" }}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={value}
          name="radio-buttons-group"
          onChange={(e) => {
            let newValue = e.target.value;
            onChangeValue(newValue);
          }}
          style={{ display: "flex", flexDirection: "row", gap: gap }}
        >
          {optionList.map((optionItem, index) => (
            <FormControlLabel
              value={optionItem}
              sx={[radioButtonStyle]}
              control={
                <Radio
                  checked={checked}
                  sx={{
                    "&.Mui-checked": {
                      color: "#175CD3",
                    },
                  }}
                  size="medium"
                />
              }
              label={optionItem}
              key={`${optionItem}_${index}`}
            />
          ))}
        </RadioGroup>
      </FormControl>
      <p style={{ color: "red", fontSize: "1.4rem" }}>{helperText}</p>
    </div>
  );
}

export default CustomRadio;
